import React, { useEffect, useState } from 'react';
import Preloader from '../components/Preloader';
import MobileMenu from '../components/MobileMenu';
import PopupSearch from '../components/PopupSearch';
import PopupSubscription from '../components/PopupSubscription';
import Header from '../components/Header';
import HeroSlider from '../components/HeroSlider';
import ProductSection1 from '../components/ProductSection1';
import CategoriesSection from '../components/CategoriesSection';
import ProductSection2 from '../components/ProductSection2';
import TestimonialSection from '../components/TestimonialSection';
import OfferSection from '../components/OfferSection';
import BlogSection from '../components/BlogSection';
import QuoteSection from '../components/QuoteSection';
import NewsletterSection from '../components/NewsletterSection';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

declare global {
  interface Window {
    $: any;
    jQuery: any;
    WOW: any;
  }
}

const Home: React.FC = () => {
   const [menuOpen, setMenuOpen] =  useState(false);
  
  useEffect(() => {
    // Initialize WOW animations
    if (typeof window.WOW !== 'undefined') {
      new window.WOW({ live: false }).init();
    }

    // Preloader hide
    const preloader = document.querySelector('.preloader') as HTMLElement;
    if (preloader) {
      setTimeout(() => {
        preloader.style.opacity = '0';
        preloader.style.transition = 'opacity 0.5s';
        setTimeout(() => { preloader.style.display = 'none'; }, 500);
      }, 800);
    }

    // Sticky header
    const stickyWrapper = document.querySelector('.sticky-wrapper') as HTMLElement;
    const handleScroll = () => {
      if (stickyWrapper) {
        if (window.scrollY > 100) {
          stickyWrapper.classList.add('sticky');
        } else {
          stickyWrapper.classList.remove('sticky');
        }
      }
    };
    window.addEventListener('scroll', handleScroll);

    // Mobile menu toggle
    const menuToggles = document.querySelectorAll<HTMLElement>('.vs-menu-toggle');
    const menuWrapper = document.querySelector<HTMLElement>('.vs-menu-wrapper');
    menuToggles.forEach((btn) => {
      btn.addEventListener('click', () => {
        menuWrapper?.classList.toggle('vs-body-visible');
      });
    });

    // Category menu toggle
    const catToggle = document.querySelector<HTMLElement>('.menu-toggle');
    const menuList = document.querySelector<HTMLElement>('.menu-list');
    if (catToggle && menuList) {
      catToggle.addEventListener('click', () => {
        menuList.classList.toggle('active');
      });
    }

    // Scroll to top visibility
    const scrollBtn = document.querySelector<HTMLElement>('.scrollToTop');
    const handleScrollBtn = () => {
      if (scrollBtn) {
        scrollBtn.style.display = window.scrollY > 300 ? 'flex' : 'none';
      }
    };
    window.addEventListener('scroll', handleScrollBtn);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollBtn);
    };
  }, []);

  return (
    <>
      <Preloader />
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />
      <PopupSubscription />
      <main className="main">
        <Header />
        <HeroSlider />
        <ProductSection1 />
        <CategoriesSection />
        <ProductSection2 />
        <TestimonialSection />
        <OfferSection />
        <BlogSection />
        <QuoteSection />
        <NewsletterSection />
        <Footer />
      </main>
      <ScrollToTop />
    </>
  );
};

export default Home;
